export interface APIResponse<T = unknown> {
  statusCode: number;
  body: T;
}

export enum UpdateVisaSupportAction {
  ASSIGN = 'ASSIGN',
  UNASSIGN = 'UNASSIGN',
}

export * from './bulk-action-payloads.js';
